export default __webpack_public_path__ + "static/media/Салбар_уулзалт_төсвийн_санхүүжилт,_хувьсах_зардлын_бүрэлдэхүүн_1652585089.9ac37558.pdf";